import './ReassignDemo.css';
import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, Outlet } from 'react-router-dom';
import close from '../../assets/design/pricing/closing-x.png';
import { getCompanyTeam, reassignDemo, refreshToken} from '../../utils/api';
import iconCompanyDefault from '../../assets/companylogos/default.png';
import Spinner from '../../components/layout/Spinner';
import { refresh } from '../../services/auth.service';
import { Users, UserPlus, CheckCircle, User } from 'lucide-react';

const imageUrl = process.env.REACT_APP_BASE_IMAGE_URL;

const ReassignDemo = ({demo_id, demos, setDemos, refresh = null}) => {
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    async function loadTeam(){
      let res = await getCompanyTeam();

      if (res.success){
        setTeam(res.data);
        setLoading(false);
      }

      else if (res.status === 403){
        let _refresh = await refreshToken();

        if (_refresh.success){
          localStorage.setItem('access_token', _refresh.data.accessToken);
          localStorage.setItem('refresh_token', _refresh.data.refreshToken);

          let res = await getCompanyTeam();

          if (res.success){
            setTeam(res.data);
            setLoading(false);
          }
        }
      }
    }

    loadTeam();
  }, []);

  async function handleReassign(id){
    let res = await reassignDemo(demo_id, id);

    if (res.success){
      setShowConfirm(true);
      let filter = demos.filter(item => item.demo_id !== demo_id);
      setDemos(filter);

      if (refresh){
        await refresh();
      }
    }

    else if (res.status === 403){
      let _refresh = await refreshToken();

        if (_refresh.success){
          localStorage.setItem('access_token', _refresh.data.accessToken);
          localStorage.setItem('refresh_token', _refresh.data.refreshToken);

          let res = await reassignDemo(demo_id, id);

          if (res.success){
            setShowConfirm(true);
            let filter = demos.filter(item => item.demo_id !== demo_id);
            setDemos(filter);

            if (refresh){
              await refresh();
            }
          }
        }
    }
  }
  
  return (
    <>
      {showConfirm === false && (
        <div className="space-y-6">
          {/* Header */}
          <div className="text-center">
            <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-full bg-purple-100">
              <Users className="w-6 h-6 text-purple-600" />
            </div>
            <h2 className='text-xl font-semibold text-gray-900'>Reassign Demo</h2>
            <p className="mt-2 text-sm text-gray-500">Select a team member to handle this demo</p>
          </div>

          <div className="flex items-center justify-center">
            <Link 
              to='/account/team' 
              className="inline-flex items-center text-sm text-purple-600 hover:text-purple-700"
            >
              <UserPlus className="w-4 h-4 mr-1" />
              Invite a team member
            </Link>
          </div>

          <div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
            {loading && (
              <div className="col-span-full flex justify-center">
                <Spinner />
              </div>
            )}
            
            {team.map(item => (
              <button
                key={item.registered_user_id}
                onClick={() => handleReassign(item.registered_user_id)}
                className="flex items-center p-4 rounded-lg border border-gray-200 hover:border-purple-500 hover:bg-purple-50 transition-all"
              >
                <div className="flex-shrink-0 mr-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-100">
                    {item.profile_image ? (
                      <img 
                        src={imageUrl + 'profileimages/' + item.profile_image} 
                        alt={item.first_name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center">
                        <User className="w-6 h-6 text-gray-400" />
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex-1 text-left">
                  <div className="font-medium text-gray-900">
                    {item.first_name ? (
                      <>
                        {item.first_name}
                        {item.last_name && ` ${item.last_name.charAt(0)}.`}
                      </>
                    ) : (
                      item.email
                    )}
                  </div>
                  {item.first_name && (
                    <div className="text-sm text-gray-500">{item.email}</div>
                  )}
                </div>
              </button>
            ))}
          </div>
        </div>
      )}

      {showConfirm === true && (
        <div className="text-center">
          <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-full bg-green-100">
            <CheckCircle className="w-6 h-6 text-green-600" />
          </div>
          <h2 className='text-xl font-semibold text-gray-900 mb-2'>
            Demo Successfully Reassigned
          </h2>
          <p className="text-gray-600 max-w-sm mx-auto">
            This demo has been reassigned. Your teammate will be notified through email and they will take it from here.
          </p>
        </div>
      )}
    </>
  );
};

export default ReassignDemo;
